/** Temporary admin-route console markers — no tokens, UIDs, or financial data. */

export function adminDiag(stage) {
  if (process.env.NODE_ENV === 'test') return;
  console.info(`[admin] ${stage}`);
}
